import { gsap, ScrollTrigger } from './cco-gsap-core';

const initializeHeroParallax = () => {
  const hero = document.querySelector('.hero.hero-columns, .page-contact section.main-content')

  if (!hero) return

  const parallaxImage = hero.querySelector('.hero-image .desktop')

  if (!parallaxImage) return

  gsap.to(parallaxImage, {
    yPercent: -20,
    ease: 'none',
    scrollTrigger: {
      trigger: hero,
      start: 'top top',
      end: 'bottom top',
      scrub: true,
    }
  })
}

export const initializeParallax = () => {
  initializeHeroParallax()
}